/* eslint-disable no-unused-vars */
/* eslint-disable max-statements */
/* eslint-disable complexity */
import React, {useEffect} from "react";
import { useHistory } from "react-router-dom";
import PropTypes from "prop-types";
import styles from "./style.css";
import { trackDesktopCustomEventsAU } from "../../../tracking";
import { AU_DESKTOP_EVENTS } from "../../../tracking/au.desktop-events";

import { getCarDetailsPageURLWithoutParam } from "../../../utils/helpers/get-detail-page-url";
import { GALLERY_TAB_TYPE } from "../../../constants/app-constants";
import HelloARView from "../hello-ar-view";
import CarGalleryDefaultView from "../car-gallery-view-default";
import parseLocationSearchParams from "../../../utils/helpers/parse-location-search-params";

const CarGalleryView = ({
    content,
    setGsGalleryDataConnect,
    isWishlisted,
    onWishlistClick = () => {},
    comingSoon = false,
    ctaProps = {},
    onClickNotifyIcon,
    isMaxHeight
}) => {
    const history = useHistory();

    const { threeSixtyViewUrl = "", interiorImages = [], exteriorImages = [], imperfectionImages = [] } = content || {};
    const imageCategory = {
        [GALLERY_TAB_TYPE.exterior]: exteriorImages,
        [GALLERY_TAB_TYPE.interior]: interiorImages,
        [GALLERY_TAB_TYPE.imperfections]: imperfectionImages
    };
    const galleryData = [];
    Object.keys(imageCategory).forEach((item, categoryIndex) => imageCategory[item].forEach(data => galleryData.push({...data, category: item, categoryIndex})));

    const {location} = history;
    const queryParams = parseLocationSearchParams(location.search);
    const {activeTab: currentTab, selectedImageIndex: currentIndex} = queryParams;

    useEffect(() => {
        if (currentTab) {
            const selectedIndex = galleryData.findIndex(item => item.category === currentTab);
            const imageIndex = parseInt(currentIndex) === 0 ? selectedIndex : parseInt(currentIndex);
            setGsGalleryDataConnect({
                activeTab: currentTab,
                selectedImageIndex: imageIndex
            });
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [currentTab, currentIndex]);

    // const onClose = () => {
    //     trackDesktopCustomEventsAU(AU_DESKTOP_EVENTS.CAR_DETAILS_IMAGE_GALLERY_VIEW_CLOSE);
    //     const detailPage = getCarDetailsPageURLWithoutParam(content);
    //     history.push(detailPage);
    //     setGsGalleryDataConnect({
    //         isOpen: false
    //     });
    // };
    // if (threeSixtyViewUrl) {
    //     return (
    //         <div styleName={isMaxHeight ? "styles.spinCarMax" : "styles.spinCar"}>
    //             {/* <HelloARView
    //                 content={content}
    //                 iframeUrl={threeSixtyViewUrl}
    //                 onClose={onClose}
    //                 onWishlistClick={onWishlistClick}
    //                 isWishlisted={isWishlisted}
    //                 ctaProps={ctaProps}
    //                 comingSoon={comingSoon}
    //             /> */}
    //             <div>HelloARView</div>
    //         </div>);
    // }

    return (
        <CarGalleryDefaultView
            onWishlistClick={onWishlistClick}
            isWishlisted={isWishlisted}
            ctaProps={ctaProps}
            comingSoon={comingSoon}
            onClickNotifyIcon={onClickNotifyIcon}
        />
    );

};

CarGalleryView.propTypes = {
    activeTab: PropTypes.string,
    setGsGalleryDataConnect: PropTypes.func,
    content: PropTypes.object,
    imageHost: PropTypes.string,
    selectedImageIndex: PropTypes.number,
    comingSoon: PropTypes.bool,
    ctaProps: PropTypes.object,
    isWishlisted: PropTypes.bool,
    onWishlistClick: PropTypes.func,
    onClickNotifyIcon: PropTypes.func,
    showGallery: PropTypes.bool,
    isMaxHeight: PropTypes.bool
};

export default CarGalleryView;
